import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import UserRole from '../../../shared/AuthRoles';
import TeamsToolbar from '../../components/Teams/TeamsToolbar';
import TeamList from '../../components/Teams/TeamList';
import { CustomButton } from '../../../layout/styledcomponents/CustomButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const TeamsListPage = () => {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');
    const loggedInUser = UserRole();
    const navigate = useNavigate();
    const theme = useTheme();

    useEffect(() => {
        if (loggedInUser.role !== 'guest_admin') {
            navigate(`/permissionDenied`, {
                state: {
                    name: 'teamPage',
                },
            });
        }
    }, [loggedInUser.role]);

    const handleBackButton = () => {
        if (
            loggedInUser?.role === 'owner_admin' ||
            loggedInUser?.role === 'owner_company'
        ) {
            navigate(`/adminCentre/host`);
        } else {
            navigate(`/adminCentre/guest`);
        }
    };

    return (
        <Grid
            sx={{
                width: '100%',
                minWidth: 0,
                justifyContent: 'left',
                alignItems: 'center',
            }}
        >
            <Typography
                variant='h1'
                sx={{
                    textAlign: 'left',
                    textTransform: 'uppercase',
                    mb: 2,
                    overflowWrap: 'anywhere',
                }}
            >
                Teams
            </Typography>
            <TeamsToolbar />
            <TeamList />

            <CustomButton
                onClick={handleBackButton}
                color='primary'
                sx={{
                    marginTop: '24px',
                    marginLeft: !isMobile || !isIpad ? '-8px' : '-18px',
                    '&:hover': {
                        cursor: 'pointer',
                        color: theme.palette.textAccent.main,
                        backgroundColor: 'transparent',
                        background: 'none',
                    },
                }}
            >
                <ArrowBackIcon />{' '}
                <Typography
                    sx={{
                        fontSize: '12px',
                        paddingLeft: '5px',
                    }}
                >
                    Back
                </Typography>
            </CustomButton>
        </Grid>
    );
};

export default TeamsListPage;
